<template>
    <div>
        <v-card>
            <v-card-title class="blue_corp white--text">
                ORDEN DE TRABAJO
                <v-spacer></v-spacer>
                <v-btn @click="search_ot()" x-small color="#EDE8D0" rounded>
                    Editar Orden de Trabajo                
                    <v-icon class="ml-2" small>find_replace</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-sheet class="mt-2" rounded="xl" style="border:1px solid lightgrey">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="7">
                                        <h4 class="mt-2">Datos del Cliente</h4>
                                    </v-col>
                                    <v-col cols="12" md="5" class="d-flex">
                                        <v-text-field v-if="btn_client!=true" class='casilla_beige text-body-2' v-model="rut" label="Rut" dense rounded></v-text-field>
                                        <v-text-field v-else class='casilla_grey text-body-2' v-model="rut" label="Rut" dense rounded readonly></v-text-field>
                                        <v-btn @click="enviarRut(rut)" class="mt-1 ml-2" fab x-small color="teal" dark><v-icon small>search</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n1">
                                    <v-col cols="12" md="5">
                                        <v-text-field v-if="existe=='no'" class='casilla_beige text-body-2' v-model="nombre" label="Nombre" dense rounded></v-text-field>
                                        <v-text-field v-else class='casilla_grey text-body-2' v-model="nombre" label="Nombre" dense rounded readonly></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-if="existe=='no'" class='casilla_beige text-body-2' v-model="telefono" label="Telefono" dense rounded></v-text-field>
                                        <v-text-field v-else class='casilla_grey text-body-2' v-model="telefono" label="Telefono" dense rounded readonly></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field v-if="existe=='no'" class='casilla_beige text-body-2' v-model="email" label="Email" dense rounded></v-text-field>
                                        <v-text-field v-else class='casilla_grey text-body-2' v-model="email" label="Email" dense rounded readonly></v-text-field>
                                    </v-col>
                                </v-row>
                                <!-- <v-row class="mt-n1">
                                    <v-col cols="12" md="6">
                                        <v-text-field v-if="existe=='no'" class='casilla_beige text-body-2' v-model="direccion" label="Direccion" dense rounded></v-text-field>
                                        <v-text-field v-else class='casilla_grey text-body-2' v-model="direccion" label="Direccion" dense rounded readonly></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-if="existe=='no'" class='casilla_beige text-body-2' v-model="comuna" label="Comuna" dense rounded></v-text-field>
                                        <v-text-field v-else class='casilla_grey text-body-2' v-model="comuna" label="Comuna" dense rounded readonly></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field v-if="existe=='no'" class='casilla_beige text-body-2' v-model="ciudad" label="Ciudad" dense rounded></v-text-field>
                                        <v-text-field v-else class='casilla_grey text-body-2' v-model="ciudad" label="Ciudad" dense rounded readonly></v-text-field>
                                    </v-col>
                                </v-row> -->
                            </v-container>
                        </v-sheet>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-sheet class="mt-2" rounded="xl" style="border:1px solid lightgrey">
                                    <v-container>
                                        <v-row class="mt-0">
                                            <v-col cols="12" md="7">
                                                <h4>Datos del Vehículo</h4>
                                            </v-col>
                                            <v-col cols="12" md="5">
                                                <h5 class="mt-n3 ml-3 grey--text">N° Serie</h5>
                                                <v-text-field class='mt-n1 casilla_beige text-body-2' v-model="serie" dense rounded></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n1">
                                            <v-col cols="12" md="5">
                                                <h5 class="mt-n3 ml-3 grey--text">Placa</h5>
                                                <v-text-field class='mt-n1 casilla_beige text-body-2' v-model="placa" dense rounded></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="7">
                                                <h5 class="mt-n3 ml-3 grey--text">Marca</h5>
                                                <v-text-field class='mt-n1 casilla_beige text-body-2' v-model="marca" dense rounded></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n1">
                                            <v-col cols="12" md="7">
                                                <h5 class="mt-n3 ml-3 grey--text">Modelo</h5>
                                                <v-text-field class='mt-n1 casilla_beige text-body-2' v-model="modelo" dense rounded></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="5">
                                                <h5 class="mt-n3 ml-3 grey--text">Año</h5>
                                                <v-text-field type='number' class='mt-n1 casilla_beige text-body-2' v-model="anio" dense rounded></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n1">
                                            <v-col cols="12" md="5">
                                                <h5 class="mt-n3 ml-3 grey--text">Color</h5>
                                                <v-text-field class='mt-n1 casilla_beige text-body-2' v-model="color_car" dense rounded></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="7">
                                                <h5 class="mt-n3 ml-3 grey--text">Kilometraje</h5>
                                                <v-text-field type='number' class='mt-n1 casilla_beige text-body-2' v-model="kilometraje" dense rounded></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n1">
                                            <v-col cols="12" md="5">
                                                <h5 class="mt-n3 ml-3 grey--text">Cilindro</h5>
                                                <v-text-field type='number' class='mt-n1 casilla_beige text-body-2' v-model="cilindro" dense rounded></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="7">
                                                <h5 class="mt-n3 ml-3 grey--text">Combustible</h5>
                                                <v-select class='mt-n1 casilla_beige text-body-2' v-model="bencina" :items="estado_bencina" dense rounded></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-sheet>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-sheet class="mt-2" rounded="xl" style="border:1px solid lightgrey">
                                    <v-container>
                                        <v-row class="mt-n2">
                                            <v-col cols="12" md="12" class="d-flex">
                                                <h4>Accesorios y Detalle del Vehículo</h4>
                                                <v-btn @click="tomarFoto()" class="mt-n2 ml-2" icon outlined color="brown">
                                                    <v-badge v-if="parseInt(badgeFoto)!=0" color="red" :content="badgeFoto" offset-x="5" offset-y="10">
                                                        <v-icon color="brown">add_a_photo</v-icon>
                                                    </v-badge>
                                                    <h4 v-else><v-icon  color="brown">add_a_photo</v-icon></h4>
                                                </v-btn>
                                                <v-btn @click="d_fotos=true" class="mt-n2 ml-4" icon outlined color="brown">
                                                    <v-icon color="orange">visibility</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-0">
                                            <v-col cols="12" md="12">
                                                <!-- <h5 class="mt-n3 ml-3 grey--text">Descripción</h5> -->
                                                <div class="d-flex">
                                                    <v-text-field class='mt-n1 casilla_beige text-body-2' label="Descripcion" v-model="accesorio" dense rounded></v-text-field>
                                                    <v-btn @click="add_accesories()" class="mt-n1 ml-2" icon small color="indigo" dark><v-icon>add_circle_outline</v-icon></v-btn>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mt-n4">
                                            <v-col cols="12" md="12">
                                                <v-simple-table fixed-header dense height="160px" style="border:1px solid lightgrey">
                                                    <thead>
                                                    <tr>
                                                        <th style="width: 50%;background-color: lightgray;" class="text-start">Accesorio y Detalle</th>
                                                        <th style="width: 20%;background-color: lightgray;" class="text-center">&nbsp;</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="item in array_accesorios" :key="item.id">
                                                            <td class="text-caption text-start">{{ item.descripcion }}</td>
                                                            <td class="text-caption text-center">
                                                                <v-icon @click="del_accesories(item)" small color="error">delete</v-icon>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-sheet>
                            </v-col>
                        </v-row>
                    </v-col>
                     <v-col cols="12" md="6">
                        <v-container>
                            <h4>Servicios</h4>
                            <v-row class="mt-0">
                                <v-col cols="12" md="8" class="d-flex">
                                    <v-text-field class='casilla_grey text-body-2' v-model="servicio" placeholder="Seleciona Servicio" dense rounded readonly></v-text-field>
                                    <v-btn @click="d_inventa=true" class="mt-1 ml-2" rounded small color="indigo" dark><v-icon small>find_replace</v-icon></v-btn>
                                </v-col>
                                <v-col cols="12" md="4" class="d-flex">
                                    <v-text-field type='number' class='casilla_beige text-body-2' v-model="valor" label="Valor" dense rounded></v-text-field>
                                    <v-btn @click="add_service()" class="mt-1 ml-2" icon small color="indigo" dark><v-icon>add_circle_outline</v-icon></v-btn>
                                </v-col>
                            </v-row>
                            <v-row class="mt-n2">
                                <v-col cols="12" md="12">
                                    <v-simple-table fixed-header dense height="130px" style="border:1px solid lightgrey">
                                        <thead>
                                        <tr>
                                            <th style="width: 50%;background-color: lightgray;" class="text-start">Descripción</th>
                                            <th style="width: 30%;background-color: lightgray;" class="text-end">Valor</th>
                                            <th style="width: 20%;background-color: lightgray;" class="text-center">&nbsp;</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in array_services" :key="item.id">
                                                <td class="text-caption text-start">{{ item.producto }}</td>
                                                <td class="text-caption text-end">{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.precio)) }}</td>
                                                <td class="text-caption text-center">
                                                    <v-icon @click="del_service(item)" small color="error">delete</v-icon>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" md="3">
                                    <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field class='mt-n2 casilla_beige text-body-2' v-model="fecha_entrega" label="Fecha Entrega" readonly v-bind="attrs" v-on="on" dense rounded></v-text-field>
                                        </template>
                                        <v-date-picker v-model="fecha_entrega" @input="menu1 = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="8" md="9" style="background-color: #042955; height: 35px;">
                                    <v-row>
                                        <v-col cols="12" md="9" class="text-end">
                                            <h4 class="mt-n1 white--text">Total Servicio:</h4>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <h3 class="mt-n1 white--text">$ {{ new Intl.NumberFormat("de-DE").format(parseFloat(total)) }}</h3>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="mt-2">
                                <v-col cols="12" md="5">
                                    <v-sheet style="border:0.5px solid lightgray" rounded="xl">
                                        <v-container>
                                            <v-row>
                                                <v-col cols="9" md="9" class="d-flex">
                                                    <v-badge v-if="parseInt(total_repuestos)!=0" color="red" :content="total_repuestos">
                                                        <h4>Repuestos del Servicio</h4>
                                                    </v-badge>
                                                    <h4 v-else>Repuestos del Servicio</h4>
                                                </v-col>
                                                <v-col cols="3" md="3" class="text-center">
                                                    <v-icon @click="d_products=true" color="indigo">add_circle_outline</v-icon>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-sheet>
                                </v-col>
                                <v-col cols="12" md="3" class="text-center">
                                    <v-btn  v-if="numero_ot!=''" class="mt-2" small rounded color="grey" dark>Generar OT</v-btn>
                                    <v-btn v-else @click="save_ot()" class="mt-2" small rounded color="teal" dark>Generar OT</v-btn>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <h5 class="mt-n3 ml-3 grey--text">N° OT</h5>
                                            <v-text-field class='mt-n1 casilla_grey text-body-2' v-model="numero_ot" dense rounded readonly></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-icon v-if="numero_ot!=''" @click="generarPDF()" large color="teal">print</v-icon>
                                            <v-icon v-else large color="grey">print</v-icon>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-divider class="mt-5 mb-5" inset color="cyan"></v-divider>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-btn v-if="numero_nv!=''" class="mt-1" small rounded color="grey" dark>Generar Nota Venta</v-btn>
                                    <v-btn v-else @click="save_nv()" class="mt-1" small rounded color="teal" dark>Generar Nota Venta</v-btn>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <h5 class="mt-n3 ml-3 grey--text">N° Nota de Venta</h5>
                                    <v-text-field class='mt-n1 casilla_grey text-body-2' v-model="numero_nv" dense rounded readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" md="1">
                                    <v-btn class="ml-5 mr-5" color="teal" icon
                                            v-clipboard:copy="copiar" v-clipboard:success="onCopy" v-clipboard:error="onError">
                                            <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" md="3" class="text-end">
                                    <v-btn @click="clsInput()" class="mt-1" small rounded color="teal" dark>Limpiar</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                     </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="margin-top:-50px">
                <span>&nbsp;</span>
            </v-card-actions>
        </v-card>

        <!-- dialogo repuestos del servicio --> 
        <v-dialog v-model="d_products" transition="dialog-bottom-transition" max-width="600" persistent>
            <v-card>
                <v-card-title>
                    <v-btn @click="d_products=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container>
                            <h4>Repuestos del Servicio</h4>
                            <v-row>
                                <v-col cols="12" md="8" class="d-flex">
                                    <v-text-field class='casilla_grey text-body-2' v-model="producto" placeholder="Seleciona Producto" dense rounded readonly></v-text-field>
                                    <v-btn @click="d_avanzado=true" class="mt-1 ml-2" rounded small color="indigo" dark><v-icon small>find_replace</v-icon></v-btn>
                                </v-col>
                            </v-row>
                            <v-row class="mt-n1">
                                <v-col cols="12" md="5">
                                    <v-select @change="myStock(bodega)" placeholder="Seleciona Bodega" class='casilla_beige text-body-2 black--text' v-model="bodega" :items="array_bodegas" item-text="name" item-value="id" dense rounded></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <h5 class="mt-n3 ml-3 grey--text">En Bodega</h5>
                                    <v-text-field class='mt-n1 casilla_grey text-body-2' v-model="numero_stock" dense rounded readonly></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" class="d-flex">
                                    <v-text-field type='number' class='casilla_beige text-body-2' v-model="cantidad" label="Cantidad" dense rounded></v-text-field>
                                    <v-btn @click="add_products()" class="mt-1 ml-2" icon small color="indigo" dark><v-icon>add_circle_outline</v-icon></v-btn>
                                </v-col>
                            </v-row>
                            <v-row class="mt-n2">
                                <v-col cols="12" md="12">
                                    <v-simple-table fixed-header dense height="175px" style="border:1px solid lightgrey">
                                        <thead>
                                        <tr>
                                            <th style="width: 50%;background-color: lightgray;" class="text-start">Producto</th>
                                            <th style="width: 30%;background-color: lightgray;" class="text-end">Cantidad</th>
                                            <th style="width: 20%;background-color: lightgray;" class="text-center">&nbsp;</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in array_products" :key="item.id">
                                                <td class="text-caption text-start">{{ item.producto}}</td>
                                                <td class="text-caption text-end">{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.cantidad)) }}</td>
                                                <td class="text-caption text-center">
                                                    <v-icon @click="del_products(item)" small color="error">delete</v-icon>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>



        <!-- dialog inventa --> 
        <v-dialog v-model="d_inventa" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_inventa=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                <v-spacer>
                    <div class="float-right">
                    <v-text-field class='ml-5 mr-2 text-caption' v-model="inventasearch" label="Buscar Servicio" dense required></v-text-field>
                    </div>
                </v-spacer>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="selec_servicio" dense dark :search="inventasearch" :headers="inventatitulo" :items="inventalista" :page.sync="inventapage" :items-per-page="inventaitemsPerPage"  @page-count="inventapageCount = $event" hide-default-footer class="elevation-1 text-size-cliente">
                </v-data-table>
                <v-pagination v-model="inventapage" :length="inventapageCount"  :total-visible="5"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- dialog avanzado --> 
        <v-dialog v-model="d_avanzado" transition="dialog-bottom-transition" max-width="60%" persistent>
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-row>
                    <v-col cols="12" md="12" class="text-end">
                        <v-btn @click="d_avanzado=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-sheet style="border:1px solid lightgray" rounded="xl">
                            <v-container>
                                <h5>VEHÍCULO</h5>
                                <v-row class="mt-5">
                                    <v-col cols="12" md="6">
                                        <!-- <v-text-field class='mt-n5 casilla_beige text-body-2' v-model="car_marca" label="Marca" dense rounded></v-text-field> -->
                                        <v-select placeholder="Marca" @change="search_modelos(car_marca)" class='mt-n5 casilla_beige text-body-2 black--text' v-model="car_marca" :items="myMarcas" dense rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <!-- <v-text-field class='mt-n5 casilla_beige text-body-2' v-model="car_modelo" label="Modelo" dense rounded></v-text-field> -->
                                        <v-select placeholder="Modelo" @change="search_cilindro()" class='mt-n5 casilla_beige text-body-2 black--text' v-model="car_modelo" :items="myModelos" dense rounded></v-select>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-5">
                                    <v-col cols="6" md="4">
                                        <v-text-field type="number" class='mt-n5 casilla_beige text-body-2' v-model="car_anio" label="Año" dense rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="6" md="4">
                                        <!-- <v-text-field @keypress="onlyDecimal" maxlength="3" class='mt-n5 casilla_beige text-body-2' v-model="car_cilindro" label="Cilindrada" dense rounded></v-text-field> -->
                                        <v-select placeholder="Cilindrada" class='mt-n5 casilla_beige text-body-2 black--text' v-model="car_cilindro" :items="myCilindros" dense rounded></v-select>
                                    </v-col>
                                    <v-col cols="12" md="4" class="text-center">
                                        <v-btn @click="searchRepuestos()" class="mt-n8" rounded color="#042955" dark small><span class="text-caption">Buscar Repuestos</span></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" rounded="xl">
                            <v-container>
                                <h5>Código OEM</h5>
                                <v-row class="mt-5">
                                    <v-col cols="12" md="12">
                                        <v-text-field class='mt-n5 casilla_beige text-body-2' v-model="codigo_oem" placeholder="Codigo" dense rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12" class="text-end">
                                        <v-btn @click="searchOem()" class="mt-n5" rounded color="#042955" dark small><span class="text-caption">Buscar Codigo</span></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="6" md="4">
                        <v-text-field class='mt-n3 ml-2 text-body-2' v-model="car_search" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                    <v-col cols="6" md="8" class="text-right">
                        <v-btn @click="clear_avanzado()" class="mt-n7" rounded color="teal" dark small><span class="text-caption">Limpiar Lista</span></v-btn>
                    </v-col>
                </v-row>
                <v-row class="mt-n7">
                    <v-col cols="12" md="12">
                        <v-data-table height="300px" dense dark :search="car_search" :headers="car_titulo" :items="car_lista" :page.sync="car_page" :items-per-page="car_itemsPerPage"  @page-count="car_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                            <template v-slot:item.accion="{ item }">
                                <v-icon @click="selec_producto(item)" color="success">add_circle_outline</v-icon>
                            </template>
                            <template v-slot:item.Codigos="{ item }">
                                <v-badge :content="item.Codigos" color="orange" overlap>
                                    <v-btn @click="getCodigos(item)" outlined rounded color="orange" x-small>
                                        ver codigos
                                    </v-btn>
                                </v-badge>
                            </template>
                            <template v-slot:item.Autos="{ item }">
                                <v-badge :content="item.Autos" color="orange" overlap>
                                    <v-btn @click="getAutos(item)" outlined rounded color="orange" x-small>
                                        ver vehículos
                                    </v-btn>
                                </v-badge>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- DIALOGO CODIGOS OEM -->
        <v-dialog v-model="d_codigos" transition="dialog-bottom-transition" max-width="500" persistent>
            <v-card>
            <v-toolbar color="primary" dark>Codigos Oem</v-toolbar>
            <v-card-text>                
                <v-row class="mt-2">
                    <v-col cols="12" md="12">
                        <v-simple-table fixed-header dense height="200px">
                            <thead>
                                <tr>
                                    <th style="background-color: beige;" class="text-start">Codigo</th>
                                    <th style="background-color: beige;" class="text-start">Proveedor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in lista_codigos" :key="item.ID">
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Codigo }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Proveedor }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="d_codigos=false" color="indigo" rounded outlined>x&nbsp;&nbsp;&nbsp;Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOGO VEHICULOS -->
        <v-dialog v-model="d_autos" transition="dialog-bottom-transition" max-width="500" persistent>
            <v-card>
            <v-toolbar color="primary" dark>Vehículos Compatibles</v-toolbar>
            <v-card-text>                
                <v-row class="mt-2">
                    <v-col cols="12" md="12">
                        <v-simple-table fixed-header dense height="200px">
                            <thead>
                                <tr>
                                    <th style="background-color: beige;" class="text-start">Marca</th>
                                    <th style="background-color: beige;" class="text-start">Modelo</th>
                                    <th style="background-color: beige;" class="text-start">Años</th>
                                    <th style="background-color: beige;" class="text-start">Cilindrada</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in lista_autos" :key="item.ID">
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Marca }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Modelo }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Desde }} - {{ item.Hasta }}</span>
                                    </td>
                                    <td class="text-start">
                                        <span class="text-caption">{{ item.Cilindro }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="d_autos=false" color="indigo" rounded outlined>x&nbsp;&nbsp;&nbsp;Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

       <v-dialog v-model="d_ots" transition="dialog-bottom-transition" max-width="75%" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_ots=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
                <v-spacer>
                    <div class="float-right">
                        <v-text-field class='ml-5 mr-2 text-caption' v-model="ot_search" label="Buscar OT" dense required></v-text-field>
                    </div>
                </v-spacer>
            </v-card-title>
            <v-card-text>
                <v-data-table height="400px" @click:row="selec_ot" dense dark :search="ot_search" :headers="ot_titulo" :items="ot_lista"
                        :page.sync="ot_page" :items-per-page="ot_itemsPerPage"  @page-count="ot_pageCount = $event" hide-default-footer class="elevation-1 text-size-cliente">
                </v-data-table>
                <!-- <v-pagination v-model="ot_page" :length="ot_pageCount"  :total-visible="5"></v-pagination> -->
            </v-card-text>
        </v-card>
        </v-dialog>

        <!-- galeria de fotos -->
         <v-dialog v-model="d_fotos" persistent max-width="400">
            <v-card>
            <v-card-title>
                Galeria de Fotos
                <v-spacer></v-spacer>
                <v-btn @click="d_fotos=false" color="red" small dark><v-icon small>close</v-icon>Close</v-btn>
            </v-card-title>
            <v-card-text>
                <div class="div1">
                    <v-row class="mt-5">
                        <v-col cols="5" v-for="foto in fotosOT" :key="foto.id">
                            <div style="position:relative">
                                <div style="position:absolute;left:80px;top:-10%">
                                    <v-btn @click="deletePhoto(foto)" fab color="red" x-small style="border:1px solid white">
                                        <v-icon color="white" small>delete</v-icon>
                                    </v-btn>
                                </div>
                                <div style="position:absolute;left:0px;top:75%">
                                    <v-btn @click="vistaPhoto(foto)" fab id="color_corp" x-small style="border:1px solid white">
                                        <v-icon id="text_color" small>visibility</v-icon>
                                    </v-btn>
                                </div>
                                <img :src="foto.foto" height="100px" width="100px" />
                                <!-- <h5>{{ foto.posicion }}</h5> -->
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">&nbsp;</v-col>
                    </v-row>
                </div>
            </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="d_vista" persistent max-width="400">
            <img :src="imgVista" height="300px" width="300px" style="border:3px white solid"/>
            <v-btn @click="d_vista=false" block>cerrar</v-btn>
        </v-dialog>


        <!-- <img id="plantilla_OT" src="@/assets/Plantilla_OT.jpg" height="0" width="0">
        <img id="logo_emisor" src="@/assets/logo_pdf.png" height="0" width="0">  -->

        
        <img id="plantilla_OT" src="@/assets/Plantilla_OT.jpg" height="0" width="0">
        
        <img id="logo_emisor" src="" height="0" width="0">  
        
       
        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"  />        
    </div>
</template>
<style scoped>
.text-size-cliente >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /*background-color: lightyellow;*/ 
}
.text-size >>> td {
    font-size: 9pt !important;
    height: 35px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
/* opciones de las fotos */
.flexbox{
    align-items: center;
    display: flex;
    height: 100px;
    justify-content: center;
    width: 100%;
}
img {
  border-radius: 10%; /* Redondea las esquinas proporcionalmente al tamaño de la imagen */
  border: 1px solid lightgrey;
}
.container {
  position: relative;
}
.left-up {
  position: absolute;
  top: 0%;
  left: 5%;
}
.rigth-up {
  position: absolute;
  top: 0%;
  left:75%;
}
.div1{
    max-height : 600px;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
<script>
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
import { jsPDF } from "jspdf";
import axios from 'axios';
export default {
    name:'OrdenTrabajo', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            existe:'',
            entidad:0,
            rut:'',
            nombre:'',
            telefono:'',
            email:'',
            direccion:'',
            comuna:'',
            ciudad:'',
            marca:'',
            modelo:'',
            color_car:'',
            anio:'',
            cilindro:'',
            placa:'',
            serie:'',
            kilometraje:'',
            bencina:'',
            estado_bencina:['Full', '3/4 Estanque', '1/2 Estanque', '1/4 Estanque', 'Reserva'],
            accesorio:'',
            array_accesorios:[],
            sku_servicio:'',
            servicio:'',
            valor:0,
            sku_producto:'',
            producto:'',
            cantidad:0,
            total:0,
            array_services:[],
            array_products:[],
            d_inventa:false,
            inventasearch:'',
            inventatitulo:[
                { text: 'Sku', align: 'start', sortable: true, value: 'Sku', width:'' },
                { text: 'Servicio', align: 'start', sortable: true, value: 'Servicio' },
            ],
            inventalista:[],
            inventapage: 1,
            inventapageCount: 0,
            inventaitemsPerPage: 10,

            car_marca:'',
            car_modelo:'',
            car_anio:'',
            car_cilindro:'',
            d_avanzado:false,
            car_search:'',
            car_titulo:[
                { text: 'Selec.', align: 'center', sortable: false, value: 'accion'},
                { text: 'Sku', align: 'start', sortable: false, value: 'Sku'},
                { text: 'Producto', align: 'start', sortable: false, value: 'Producto'},
                { text: 'Stock', align: 'center', sortable: false, value: 'Stock'},
                { text: 'Codigos Oem', align: 'center', sortable: false, value: 'Codigos'},
                { text: 'Compatibilidad', align: 'center', sortable: false, value: 'Autos'},
            ],
            car_lista:[],
            car_page: 1,
            car_itemsPerPage: 1000000,
            car_pageCount: 0,
            d_codigos:false,
            lista_codigos:[],
            d_autos:false,
            lista_autos:[],
            myMarcas:[],
            myModelos:[],
            myCilindros:[],
            codigo_oem:'',

            numero_ot:'',
            numero_nv:'',
            array_category:[],
            d_products:false,
            total_repuestos:0,
            date_ot: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            btn_client:false,
            bodega:0,
            bodegas:[],
            array_bodegas:[],
            numero_stock:'',

            d_ots:false,
            ot_search:'',
            ot_titulo:[
                { text: 'Fecha', align: 'start', sortable: true, value: 'Fecha', width:'' },
                { text: 'Numero OT', align: 'start', sortable: true, value: 'OT' },
                { text: 'Nombre Cliente', align: 'start', sortable: true, value: 'Nombre' },
                { text: 'Placa Patente', align: 'start', sortable: true, value: 'Placa' },
                { text: 'Marca', align: 'start', sortable: true, value: 'Marca' },
                { text: 'Modelo', align: 'start', sortable: true, value: 'Modelo' },
                { text: 'Nota Venta', align: 'end', sortable: true, value: 'Orden' },
            ],
            ot_lista:[],
            ot_page: 1,
            ot_pageCount: 0,
            ot_itemsPerPage: 1000000,
            copiar:'',

            emisorPDF:[],

            fotosOT:[],
            badgeFoto:0,
            d_fotos:false,
            d_vista:false,
            imgVista:'',
            menu1: false,
			fecha_entrega: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

        }
    },
    async mounted(){
        //asignamos la plantilla OT al document
        // var img_plantilla = document.getElementById("plantilla_OT")
        // img_plantilla.src = process.env.VUE_APP_URL + '/templates/Plantilla_OT.jpg';
        await this.search_categorias();
        await this.search_marcas();
        await this.buscarProducto();
        await this.searchBodegas();
        await this.searchEmisor();
    },
    methods:{
        onCopy: function (e) {
            this.Msg='Nota de Venta '+ e.text +' Copiada';
            this.msgbox=true;
            this.color='orange';
            this.showSnack();
        },
        onError: function (e) {
            this.Msg='Nota de Venta NO Copiada';
            this.msgbox=true;
            this.color='red';
            this.showSnack();
        },
        async tomarFoto() {
            const image = await Camera.getPhoto({
                quality: 50,
                allowEditing: true,
                //resultType: CameraResultType.Uri,
                resultType: CameraResultType.Base64,
                source: CameraSource.Camera,
                //width: 200, // Redimensionar ancho
                //height: 200, // O redimensionar alto
            });
            if(image){
                const myPhoto = 'data:image/jpeg;base64,' + image.base64String;
                const saveFoto = await this.grabarFoto(myPhoto);
                if(saveFoto){
                    this.badgeFoto = parseInt(this.badgeFoto) + 1;
                    if(this.numero_ot!=''){
                        await this.savePhoto();
                    }
                }
            } 
        },
        async vistaPhoto(foto){
            this.imgVista = foto.foto;
            this.d_vista=true
        },
        async deletePhoto(foto){            
            try {
                if(this.numero_ot!=''){
                    if(parseInt(this.numero_ot)!=0){
                        const par_delete = this.contrato + '/' + this.numero_ot + '/' + foto.id;
                        const res_delete = await axios.delete(process.env.VUE_APP_URL + '/api/inv/ot_photo/delete/' + par_delete);
                        const data_delete = res_delete.data;
                        console.log('Delete Photo', data_delete)
                    }
                };
                if(this.fotosOT.length!=0){
                    this.fotosOT = this.fotosOT.filter(function(dat) {
                        return dat.id !== foto.id; 
                    });
                };
                this.badgeFoto=this.fotosOT.length
            } catch (error) {
                console.log(error)
            }
        },
        async savePhoto(){
            try {
                //elimino todas las fotos de la orden para grabar las nuevas fotos
                const par_delete = this.contrato + '/' + this.numero_ot;
                const response_delete = await axios.delete(process.env.VUE_APP_URL + '/api/inv/ot_photo/all_delete/' + par_delete);
                const result_delete = response_delete.data;
                if(result_delete!='error'){
                    //grabamos las nuevas fotos
                    for (let index = 0; index < this.fotosOT.length; index++) {
                        const element = this.fotosOT[index];
                        const params = {
                            'contrato': this.contrato,
                            'ot': this.numero_ot,
                            'foto': element.foto,
                        };
                        //insertamos datos en identity_ot
                        const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/ot_photo/save/',params);
                        const datos=response.data;
                        if(datos=='si'){
                            console.log('Foto ok')
                        } 
                    };
                    await this.getPhotosOT()
                }
            } catch (error) {
                console.log(error)
            }
        },
        async getPhotosOT(){
            try {
                this.fotosOT=[];
                const params = this.contrato + '/' + this.numero_ot;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/ot_photo/get/' + params);
                const datos = response.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.fotosOT.push({
                            'id': element.ID,
                            'foto': element.Foto,
                        })
                    });    
                };
                this.badgeFoto=this.fotosOT.length;
            } catch (error) {
                console.log(error)
            }
        },
        async grabarFoto(img){
            let result = false;
            try {
                if(this.fotosOT.length!=0){
                    if(this.fotosOT.length < 4){
                        const mayorId = Math.max(...this.fotosOT.map(item => item.id));
                        const index = parseInt(mayorId) + 1;
                        this.fotosOT.push({
                            "id": index,
                            "foto": img
                        });
                        result = true;
                    } else {
                        this.Msg='Cuota de fotos completada';
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                } else {
                    this.fotosOT.push({
                        "id": 1,
                        "foto": img
                    });
                    result = true;
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async search_ot(){
            this.loading=true;
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/ot/search/'+ this.contrato);
                const datos=response.data;
                if(datos[0].existe=='si'){
                    this.ot_lista = datos;
                    this.d_ots=true
                }
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async selec_ot(item){
            this.existe = 'no';
            this.btn_client = true;
            this.rut = item.Rut;
            this.nombre = item.Nombre;
            this.telefono = item.Telefono;
            this.email = item.Email;
            this.marca = item.Marca;
            this.modelo = item.Modelo;
            this.anio = item.Anio;
            this.cilindro = item.Cilindro;
            this.color_car = item.Color;
            this.kilometraje = item.Kilometraje;
            this.bencina = item.Combustible;
            this.placa = item.Placa;
            this.serie = item.Serie;
            this.fecha_entrega = item.Entrega;

            let response;
            let datos;
            const params = this.contrato + '/' + item.OT;

            //buscar los accesorios
            this.array_accesorios=[];
            response = await axios.get(process.env.VUE_APP_URL + '/api/inv/ot_accesories/get/' + params);
            datos=response.data;
            if(datos[0].existe=='si'){
                datos.forEach(element => {
                    this.array_accesorios.push({
                        'id': element.ID,
                        'descripcion': element.Descripcion
                    })
                });    
            };
            //buscar los servicios
            this.array_services=[];
            response = await axios.get(process.env.VUE_APP_URL + '/api/inv/ot_services/get/' + params);
            datos=response.data;
            if(datos[0].existe=='si'){
                datos.forEach(element => {
                    this.array_services.push({
                        'id': element.ID,
                        'sku': element.Sku,
                        'producto': element.Servicio,
                        'precio': element.Precio,
                        'cantidad': element.Cantidad
                    })
                });    
            };

            //buscar los productos
            this.array_products=[];
            response = await axios.get(process.env.VUE_APP_URL + '/api/inv/ot_product/get/' + params);
            datos=response.data;
            if(datos[0].existe=='si'){
                datos.forEach(element => {
                    this.array_products.push({
                        'id': element.ID,
                        'sku': element.Sku,
                        'producto': element.Producto,
                        'precio': element.Precio,
                        'cantidad': element.Cantidad,
                        'bodega': element.Bodega
                    })
                });    
            };
            //buscar fotos
            this.fotosOT=[];
            response = await axios.get(process.env.VUE_APP_URL + '/api/inv/ot_photo/get/' + params);
            datos=response.data;
            if(datos[0].existe=='si'){
                datos.forEach(element => {
                    this.fotosOT.push({
                        'id': element.ID,
                        'foto': element.Foto,
                    })
                });    
            };
            this.badgeFoto=this.fotosOT.length;
            this.total_repuestos = this.array_products.length;
            this.numero_ot = item.OT;
            if(parseFloat(item.Orden)!=0){
                this.numero_nv = item.Orden;
                this.copiar = '' + this.numero_nv
            } else {
                this.numero_nv = '';
                this.copiar = ''
            }
            this.d_ots = false
        },
        async searchBodegas(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+ this.contrato);
                const datos=response.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.bodegas.push({
                            'id':element.ID,
                            'name':element.Nombre
                        })
                    });                
                }
            } catch (error) {
                console.log(error)               
            }
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        enviarRut(rutCompleto){
            let ruts=this.validaRut(rutCompleto);
            if (ruts){
                this.verCliente(rutCompleto);
                this.btn_client=true;
            } else {
                this.Msg='Rut no Valido'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        validaRut(rutCompleto){
            if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
			    return false;
		    var tmp 	= rutCompleto.split('-');
		    var digv	= tmp[1]; 
		    var ruti 	= tmp[0];
		    if ( digv == 'K' ) digv = 'k' ;
		    return (this.dv(ruti) == digv );
        },
        dv(T){
            var M=0,S=1;
    		for(;T;T=Math.floor(T/10))
	    		S=(S+T%10*(9-M++%6))%11;
		    return S?S-1:'k';
        },
        clsInput(){
            this.existe='';
            this.entidad='';
            this.rut='';
            this.nombre='';
            this.telefono='';
            this.email='';
            this.direccion='';
            this.comuna='';
            this.ciudad='';
            this.marca='';
            this.modelo='';
            this.color_car='';
            this.anio='';
            this.cilindro='';
            this.placa='';
            this.serie='';
            this.kilometraje='';
            this.bencina='';
            this.accesorio='';
            this.array_accesorios=[];
            this.sku_servicio='';
            this.servicio='';
            this.valor=0;
            this.sku_producto='';
            this.producto='';
            this.cantidad=0;
            this.total=0;
            this.array_services=[];
            this.array_products=[];
            this.car_marca='';
            this.car_modelo='';
            this.car_anio='';
            this.car_cilindro='';
            this.numero_ot='';
            this.numero_nv='';
            this.total_repuestos=0;
            this.date_ot= (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.btn_client=false;
            this.copiar='';
            this.fotosOT=[];
            this.badgeFoto=0;
            this.imgVista='';
			this.fecha_entrega=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);

        },
        async verCliente(xRut){
             this.loading=true;
             this.msgbox=false;
            if(xRut.trim()!=''){
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/clientes/'+this.contrato+'/'+ xRut);
                const datos=response.data;
                if (datos[0].existe=='no'){
                    this.existe='no'
                }
                if (datos[0].existe=='error'){
                    this.Msg='Conexion Inestable, intentelo mas tarde'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
                if (datos[0].existe=='si'){               
                    this.existe='si';
                    this.entidad=datos[0].ID;
                    this.rut=datos[0].Rut;
                    this.nombre=datos[0].Nombre;
                    this.telefono=datos[0].Telefono;
                    this.direccion=datos[0].Direccion;
                    this.comuna=datos[0].Comuna;
                    this.ciudad=datos[0].Ciudad;
                    this.email=datos[0].Email;
                } 
            } else {
                this.existe=''
            }
            this.loading=false;
        },
        async search_categorias(numeroCategoria){
            this.array_category=[];
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/categorias/'+ this.contrato);
            const datos=response.data;
            if(datos[0].existe=='si'){
                this.array_category=datos;
            }
        },        
        async buscarProducto(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/productos/'+this.contrato);
            const datos=response.data;
            this.inventalista=[];
            if (datos[0].existe=='si'){
                for (let index = 0; index < datos.length; index++) {
                    const element = datos[index];
                    let nameCategory = '';
                    const found = this.array_category.filter(res => parseInt(res.ID)==parseInt(element.Categoria));
                    if(found.length!=0){ 
                        nameCategory = found[0].Nombre
                    };
                    if(nameCategory == 'Servicios' || nameCategory == 'SERVICIOS' || 
                        nameCategory == 'Servicio' || nameCategory == 'SERVICIO'){
                        this.inventalista.push({'Sku':element.Sku,'Servicio':element.Nombre});
                    }
                }
            }
        },
        handleInventa(line){
            this.verSku(line.iSku);
            this.d_inventa=false
        },
        async search_marcas(){
            try {
                this.myMarcas=['FULL-MARCAS'];
                const params = this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/marcas/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myMarcas.push(element.Marca);
                    })
                }              
            } catch (error) {
                console.log(error)
            }
        },
        async search_modelos(marca){
            try {
                this.myModelos=['FULL-MODELOS'];
                const params = marca + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/modelo/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myModelos.push(element.Modelo);
                    })
                }              
            } catch (error) {
                console.log(error)
            }
        },
        async search_cilindro(){
            try {
                this.myCilindros=['FULL-CILINDRADA'];
                const params = this.car_marca + '/' + this.car_modelo + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/cilindro/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myCilindros.push(element.Cilindro);
                    })
                }              
            } catch (error) {
                console.log(error)
            }
        },
        async searchRepuestos(){
            this.codigo_oem='';
            if(this.car_marca==null || this.car_marca==''){
                this.car_marca = "FULL-MARCAS"
            }
            if(this.car_modelo==null || this.car_modelo==''){
                this.car_modelo='FULL-MODELOS'
            }
            if(this.car_anio==null || this.car_anio==''){
                this.car_anio = 0
            }
            if(this.car_cilindro==null || this.car_cilindro==''){
                this.car_cilindro='FULL-CILINDRADA'
            }
            try {
                const params = this.contrato + '/' + this.car_marca + '/' + this.car_modelo + '/' + this.car_anio + '/' + this.car_cilindro;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/repuestos/' + params);
                const datos=response.data;
                this.car_lista=[];
                if (datos[0].existe=='si'){
                    this.car_lista=datos;
                }                    
            } catch (error) {
                console.log(error)
            }
        },
        async searchOem(){
            if(this.codigo_oem!=null && this.codigo_oem!=''){
                this.car_marca='';
                this.car_modelo='';
                this.car_anio='';
                this.car_cilindro='';
                this.myCilindros=[];
                this.myModelos=[];
                this.lista_codigos=[];
                this.lista_autos=[];
                try {
                    const params = this.codigo_oem  + '/' + this.contrato;
                    const response = await axios.get(process.env.VUE_APP_URL + '/api/control/codigoem/' + params);
                    const datos=response.data;
                    this.car_lista=[];
                    if (datos[0].existe=='si'){
                        this.car_lista=datos;
                    }                    
                } catch (error) {
                    console.log(error)
                }                
            }
        },
        async getCodigos(line){
            this.loading=true;
            try {
                this.lista_codigos=[];
                const params = line.Sku + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/codigos/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.lista_codigos = datos;
                    this.d_codigos = true;
                }  
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async getAutos(line){
            this.loading=true;
            try {
                this.lista_autos=[];
                const params = line.Sku + '/' + this.contrato;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/control/Compatibles/' + params);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.lista_autos = datos;
                    this.d_autos = true;
                }  
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async selec_producto(select){
            this.loading=true;
            this.bodega=0;
            this.array_bodegas=[];
            await this.sku_stock(select.Sku);
            this.sku_producto = select.Sku;
            this.producto = select.Producto;
            this.d_avanzado=false;
            this.loading=false;
        },
        async selec_servicio(select){
            this.sku_servicio = select.Sku;
            this.servicio = select.Servicio;
            this.d_inventa=false;
        },
        clear_avanzado(){
            this.car_marca='';
            this.car_modelo='';
            this.car_anio='';
            this.car_cilindro='';
            this.myCilindros=[];
            this.myModelos=[];
            this.lista_codigos=[];
            this.lista_autos=[];
            this.car_lista=[];
            this.codigo_oem='';
        },
        add_accesories(){
            if(this.accesorio!=null && this.accesorio!=''){
                let index = 1;
                if(this.array_accesorios.length!=0){
                    //ordenar objeto
                    this.array_accesorios.sort(((a, b) => parseInt(a.id) - parseInt(b.id)));
                    //obtener el ultimo id del objeto
                    const last_id = this.array_accesorios.length - 1;
                    const id_value = this.array_accesorios[last_id].id;
                    index = id_value + 1;
                };
                this.array_accesorios.push({
                    'id': index,
                    'descripcion': this.accesorio,
                });
                this.accesorio='';
            }
        },
        del_accesories(item){
            this.array_accesorios = this.array_accesorios.filter(function(reg) {
                return reg.id !== item.id; 
            });
        },
        add_service(){
            if(this.valor!=null && this.valor!=''){
                let index = 1;
                if(this.array_services.length!=0){
                    //ordenar objeto
                    this.array_services.sort(((a, b) => parseInt(a.id) - parseInt(b.id)));
                    //obtener el ultimo id del objeto
                    const last_id = this.array_services.length - 1;
                    const id_value = this.array_services[last_id].id;
                    index = id_value + 1;
                };
                this.array_services.push({
                    'id': index,
                    'sku': this.sku_servicio,
                    'producto': this.servicio,
                    'precio': this.valor,
                    'cantidad': 1
                });
                //sumar total
                this.total = parseFloat(this.total) + parseFloat(this.valor);
                this.sku_servicio='';
                this.servicio='';
                this.valor=0;
            }
        },
        del_service(item){
            const price = item.precio;
            this.array_services = this.array_services.filter(function(reg) {
                return reg.id !== item.id; 
            });
            //restamos el precio eliminado
            this.total = parseFloat(this.total) - parseFloat(price);
        },
        add_products(){
            if(this.cantidad!=null && this.cantidad!=''){
                let index = 1;
                if(this.array_products.length!=0){
                    //ordenar objeto
                    this.array_products.sort(((a, b) => parseInt(a.id) - parseInt(b.id)));
                    //obtener el ultimo id del objeto
                    const last_id = this.array_products.length - 1;
                    const id_value = this.array_products[last_id].id;
                    index = id_value + 1;
                };
                this.array_products.push({
                    'id': index,
                    'sku': this.sku_producto,
                    'producto': this.producto,
                    'precio': 0,
                    'cantidad': this.cantidad,
                    'bodega': this.bodega
                });
                this.sku_producto='';
                this.producto='';
                this.cantidad=0;
                this.bodega=0;
                this.array_bodegas=[];
                this.numero_stock='';
                this.total_repuestos=this.array_products.length;
            }
        },
        del_products(item){
            this.array_products = this.array_products.filter(function(reg) {
                return reg.id !== item.id;
            });
            this.total_repuestos=this.array_products.length;
        },
        async obtener_ot(){
            let result = 0;
            this.numero_ot = 0;
            try {
                const date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
                const code = Math.floor(Math.random()*(999999999-100000000+1))+100000000;
                const user = this.usu;
                const params = {
                    'contrato': this.contrato,
                    'usuario': user,
                    'fecha': date,
                    'codigo': code
                };
                //insertamos datos en identity_ot
                const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/identity/save/',params);
                const datos=response.data;
                if(datos=='si'){ 
                    //rescatamos el id de identity_ot
                    const par = this.contrato + '/' + user + '/' + date + '/' + code; 
                    const res = await axios.get(process.env.VUE_APP_URL + '/api/inv/identity/get/' + par);
                    const data_res = res.data;
                    if(data_res[0].existe=='si'){
                        if(data_res.length!=1){
                            //buscamos cual ID no exste en las ordenes de trabajo
                            for (let index = 0; index < data_res.length; index++) {
                                const element = data_res[index];
                                const par1 = this.contrato + '/' + element.ID;
                                const res1 = await axios.get(process.env.VUE_APP_URL + '/api/inv/id_ot/get/' + par1);
                                const data1 = res1.data;
                                if(data1[0].existe=='no'){
                                    this.numero_ot = data_res[0].ID;
                                    break // salir del for
                                };
                            }
                        } else {
                            this.numero_ot = data_res[0].ID;
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            };
            result = this.numero_ot;
            return result
        },
        async save_ot(){
            this.loading=true;
            if(this.rut!=null && this.rut!='' &&
                this.nombre!=null && this.nombre!=''){
                if(this.marca!=null && this.marca!='' &&
                    this.modelo!=null && this.modelo!='' && this.placa!=null && this.placa!=''){
                    if(this.array_services.length!=0){
                        try {
                            const numberOT = await this.obtener_ot();
                            if(parseInt(numberOT)!=0){
                                const params = {
                                    'contrato': this.contrato,
                                    'OT': numberOT, 
                                    'Orden': 0, 
                                    'Rut': this.rut, 
                                    'Nombre': this.nombre, 
                                    'Direccion': this.direccion, 
                                    'Comuna': this.comuna, 
                                    'Ciudad': this.ciudad, 
                                    'Telefono': this.telefono, 
                                    'Marca': this.marca, 
                                    'Modelo': this.modelo, 
                                    'Anio': this.anio, 
                                    'Cilindro': this.cilindro, 
                                    'Color': this.color_car, 
                                    'Kilometraje': this.kilometraje, 
                                    'Combustible': this.bencina, 
                                    'Placa': this.placa, 
                                    'Serie': this.serie,
                                    'Fecha': this.date_ot,
                                    "Entrega": this.fecha_entrega,
                                    'Usuario': this.usu, 
                                    'Estado': 'V'
                                };
                                const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/ot/save/',params);
                                const datos=response.data;
                                if(datos=='si'){
                                    const resultado = await this.save_services(numberOT);
                                    if(resultado){
                                        await this.save_accesories(numberOT);
                                        await this.save_products(numberOT);
                                        if(this.existe=='no') { await this.save_client() };
                                        await this.savePhoto();
                                        this.Msg='La OT fue generada con exito'
                                        this.msgbox=true;
                                        this.color='success';
                                        this.showSnack();
                                    }
                                } else {
                                    this.Msg='La OT no pudo ser generada, intentelo mas tarde'
                                    this.msgbox=true;
                                    this.color='red';
                                    this.showSnack();
                                }
                            } else {
                                this.Msg='No es posible obtener numero OT'
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack();
                            }
                        } catch (error) {
                            console.log(error);
                            this.Msg='error global, favor informar a soporte'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }                
                    } else {
                        this.Msg='No existen datos en la lista de servicios'
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                    }
                } else {
                    this.Msg='Ingrese datos del vehiculo'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='Ingrese datos del cliente'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            };
            this.loading=false;
        },
        async save_services(numberOT){
            let result = false
            try {
                //borrar productos de la OT
                const par_delete = this.contrato + '/' + numberOT;
                const res_delete = await axios.delete(process.env.VUE_APP_URL + '/api/inv/ot_services/delete/' + par_delete);
                const data_delete = res_delete.data;
                if(data_delete!='error'){
                    for (let index = 0; index < this.array_services.length; index++) {
                        const element = this.array_services[index];
                        const params = {
                            'contrato': this.contrato,
                            'ot': numberOT, 
                            'sku': element.sku, 
                            'producto': element.producto, 
                            'precio': element.precio, 
                            'cantidad': element.cantidad
                        };
                        const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/ot_services/save/',params);
                        const datos=response.data;
                        if(datos=='si'){
                            console.log('save servicio ok', element.producto)
                            result = true
                        }                    
                    }
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async save_products(numberOT){
            if(this.array_products.length!=0){
                try {
                    //borrar productos de la OT
                    const par_delete = this.contrato + '/' + numberOT;
                    const res_delete = await axios.delete(process.env.VUE_APP_URL + '/api/inv/ot_products/delete/' + par_delete);
                    const data_delete = res_delete.data;
                    if(data_delete!='error'){
                        for (let index = 0; index < this.array_products.length; index++) {
                            const element = this.array_products[index];
                            const params = {
                                'contrato': this.contrato,
                                'ot': numberOT, 
                                'sku': element.sku, 
                                'producto': element.producto, 
                                'precio': element.precio, 
                                'cantidad': element.cantidad,
                                'bodega': element.bodega
                            };
                            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/ot_products/save/',params);
                            const datos=response.data;
                            if(datos=='si'){
                                console.log('save producto ok', element.producto)
                            }                    
                        }
                    }
                } catch (error) {
                    console.log(error)
                }
            }
        },
        async save_accesories(numberOT){
            if(this.array_accesorios.length!=0){
                try {
                    //borrar accesorios de la OT
                    const par_delete = this.contrato + '/' + numberOT;
                    const res_delete = await axios.delete(process.env.VUE_APP_URL + '/api/inv/ot_accesories/delete/' + par_delete);
                    const data_delete = res_delete.data;
                    if(data_delete!='error'){
                        for (let index = 0; index < this.array_accesorios.length; index++) {
                            const element = this.array_accesorios[index];
                            const params = {
                                'contrato': this.contrato,
                                'ot': numberOT, 
                                'descripcion': element.descripcion,
                            };
                            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/ot_accesories/save/',params);
                            const datos=response.data;
                            if(datos=='si'){
                                console.log('save accesorio ok', element.descripcion)
                            }                    
                        }
                    }
                } catch (error) {
                    console.log(error)
                }
            }
        },
        fechaNacional(fec){
            const dia = fec.substring(8,10);
            const mes = fec.substring(5,7);
            const anio = fec.substring(0,4);
            const hoy = dia + '-' + mes + '-' + anio;
            return hoy;
        },
        async searchEmisor(){
            try {
                this.emisorPDF=[];
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/emisor/' + this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.emisorPDF=datos;
                    //agregamos el logo al id
                    var img_logo = document.getElementById("logo_emisor")
                    img_logo.src = datos[0].Logo;
                }
            } catch (error) {
               console.log(error) 
            }
        },        
        async generarPDF(){
            try {
                const doc = new jsPDF('p', 'mm', 'letter');
                //doc.addPage('p','mm','letter')

                var img_fondo = document.getElementById("plantilla_OT");
                doc.addImage(img_fondo,'JPG',2,2,213,277,'aliasFondo');

                //logo
                var img_logo = document.getElementById("logo_emisor");
                doc.addImage(img_logo,'PNG',2,2,50,35,'aliasLogo');

                
                doc.setFont("Helvetica", "bold");
                //tamaño de letra
                doc.setFontSize(15);
                //color de la letra = rojo
                doc.setTextColor(255,0,0);
                const txtnumero = '000000' + this.numero_ot;
                const numero_servicio = txtnumero.slice(-6);
                doc.text(('' + numero_servicio).toString(), 182, 30,{align: 'center'});

                doc.setTextColor('#000');
                doc.setFont("Helvetica", "normal");

                doc.setFontSize(12);
                //datos del vehiculo
                doc.text('' + this.marca, 28, 52.5);
                doc.text('' + this.modelo, 30, 59.5);
                doc.text('' + this.color_car, 74, 59.5);
                doc.text('' + this.kilometraje, 36, 66.5);
                doc.text('' + this.placa, 76, 66.5);
                doc.text('' + this.serie, 45, 73);

                //datos del cliente
                doc.text('' + this.fechaNacional(this.date_ot), 125, 52.5);
                doc.text('' + this.nombre, 128, 59.5);
                doc.text('' + this.telefono, 128, 66);
                doc.text('' + this.email, 122, 73); // email

                //servicios
                let line=98;
                console.log(this.array_services);
                this.array_services.forEach(element => {
                    doc.text('' + element.producto, 15, line);
                    line = line + 6;
                });
      
                //accesorios y detalle
                line=167;
                console.log(this.array_accesorios);
                this.array_accesorios.forEach(element => {
                    doc.text('' + element.descripcion, 15, line);
                    line = line + 6;
                });

                //combustible
                doc.text('' + this.bencina, 176, 207,{align: 'center'});
                doc.text('__________', 176, 230,{align: 'center'});
                //fecha de entrega
                doc.text('Fecha de Entrega Estimada', 176, 240,{align: 'center'});
                doc.text('' + this.fechaNacional(this.fecha_entrega), 176, 245,{align: 'center'});

                doc.output('dataurlnewwindow')
            } catch (error) {
                console.log(error)
            }
        },
        async save_client(){
            try {
                var parametros={
                    'contrato': this.contrato,
                    'rut': this.rut,
                    'nombre': this.nombre,
                    'direccion': '',
                    'ciudad': '',
                    'comuna': '',
                    'telefono': this.telefono,
                    'email': this.email,
                    'observacion': '',
                    'estado': 'V',
                    'credito':'NO',
                    'dias':'0',
                    'precio': 'Precio Detalle',
                    'contacto': '',
                    'alias': '',
                    'vendedor': '0',
                };
                const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/v4/clientes/nuevo',parametros);
                const datos=response.data;
                if (datos=='si'){
                    console.log('save client ok');
                    this.entidad = await this.search_entidad(this.rut);
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_entidad(xRut){
            let result = 0;
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/clientes/'+this.contrato+'/'+ xRut);
                const datos=response.data;
                if (datos[0].existe=='no'){
                    result = datos[0].ID;
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async save_nv(){
            this.loading=true;
            const cotiza = await this.saveCotiza();
            if(parseFloat(cotiza)!=0){
                //update OT vs Orden
                const params={
                    'contrato': this.contrato,
                    'ot': this.numero_ot,
                    'orden': cotiza
                }
                const response = await axios.put(process.env.VUE_APP_URL + '/api/inv/ot_order/save/', params);
                const datos=response.data;
                if(datos=='si'){
                    this.numero_nv = cotiza;
                    this.copiar='' + this.numero_nv;
                    this.Msg='Nota de venta creada con exito'
                    this.msgbox=true;
                    this.color='success';
                    this.showSnack();
                } else {
                    this.Msg='Nota de Venta NO creada'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='No fue posible crear Nota de Venta'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            };
            this.loading=false;
        },
        async saveCotiza(){
            let todos='si';
            const timestamp = Date.now();
            let orden =  '88' + timestamp.toString();
            let result = 0;
            if(this.array_services.length!=0){
                for (let index = 0; index < this.array_services.length; index++) {
                    const element = this.array_services[index];
                    var parametros={
                        'contrato': this.contrato,
                        'orden': orden,
                        'entidad': this.entidad,
                        'tipo': 'Neto',
                        'cv': 'V',
                        'sku':element.sku,
                        'producto':element.producto,
                        'precio':element.precio,
                        'cantidad':element.cantidad,
                        'descuento': '0',
                        'concepto': '',
                        'bodega': '999', // bodega que no descontara stock
                        'observa':'',
                        'usuario':this.usu,
                        'referencia':'0'
                    };
                    const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/compraventa/nueva/v5',parametros);
                    const datos=response.data;
                    //console.log(datos);
                    if (datos!='si'){ 
                        todos='no'
                    }
                };
                if(todos!='si'){
                    // eliminar cotiza
                    const response = await axios.delete(process.env.VUE_APP_URL + '/api/inv/orden/delete/'+this.contrato+'/'+this.orden);
                    const datos=response.data;
                } else {
                    console.log('Cotizacion Grabada');
                    result =  orden
                }
            };
            return result
        },
        async sku_stock(xSku){
            let nStock=0;
            //recorrer todas las bodegas
            for (let index = 0; index < this.bodegas.length; index++) {
                const element = this.bodegas[index];
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/stock/bodegas/producto/total/'+ this.contrato +'/'+ element.id + '/' + xSku);
                const datos=response.data;
                if (datos[0].existe=='si'){ 
                    if(parseFloat(datos[0].Total)!=0){
                        this.array_bodegas.push({
                            'id': element.id,
                            'name': element.name,
                            'stock': datos[0].Total
                        })
                    }
                }
            }
        },
        myStock(bode){
            const stock_bodega = this.array_bodegas.filter(res => parseInt(res.id) == parseInt(bode));
            if(stock_bodega.length!=0){
                this.numero_stock = stock_bodega[0].stock;
            }

        }

    }
}
</script>
